import React, { useEffect, useState } from "react";
import { Col, Row } from "antd";
import api from "utils/api";
import {
  AllTicketNewIcon,
  SnoozeTicketNewIcon,
  ResolvedTicketNewIcon,
  OPENTICKETNewIcon,
} from "Common/ReactIcons";
import CustomDashboardCard from "./CustomDashboardCard";
function SuperAdminDashboard() {
  const [ticketsValue, setTicketsValue] = useState({});
  useEffect(() => {
    const fetchDashboardData = async () => {
      try {
        const response = await api.get_dashboard_data();
        if (
          response.data.status === 200 &&
          response.data.message === "success"
        ) {
          setTicketsValue(response.data.data || {});
        } else {
          console.error("Unexpected response:", response.data);
        }
      } catch (error) {
        console.error("Error fetching dashboard data:", error);
      }
    };

    fetchDashboardData();
  }, []);
  const dashboardCards = [
    {
      value: ticketsValue.total_tickets ?? 0,
      label: "All Tickets",
      labelColor: "red",
      icon: <AllTicketNewIcon />,
    },
    {
      value: ticketsValue.open_tickets ?? 0,
      label: "Open Tickets",
      labelColor: "green",
      icon: <OPENTICKETNewIcon />,
    },
    {
      value: ticketsValue.resolved_tickets ?? 0,
      label: "Resolved Tickets",
      labelColor: "black",
      icon: <ResolvedTicketNewIcon />,
    },
    {
      value: ticketsValue.snoozed_tickets ?? 0,
      label: "Snoozed Tickets",
      labelColor: "black",
      icon: <SnoozeTicketNewIcon />,
    },
    {
      value: ticketsValue.pending_tickets ?? 0,
      label: "Pending Tickets",
      labelColor: "green",
      icon: <SnoozeTicketNewIcon />,
    },
  ];
  return (
    <>
      <Row gutter={[12, 12]} justify="space-around">
        {dashboardCards.map((item, index) => (
          <Col
            xs={24}
            sm={12}
            md={8}
            lg={4}
            xl={4}
            // lg={index == 0 || index == 3 ? 6: 4}
            // xl={index == 0 || index == 4 ? 6 : 4}
          >
            <CustomDashboardCard index={index} item={item} />
          </Col>
        ))}
      </Row>
    </>
  );
}

export default SuperAdminDashboard;
